import React from 'react';
import { Overview } from 'src/features/MM/components/templates/Overview';
import { Page } from '../../components/molecules/Page';
import { FilterBar } from '../../components/organisms/FilterBar';
import { MMKeyMetrics } from '../../features/MM/components/organisms/MMKeyMetrics';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const OverviewPage: React.FC = () => {
  return (
    <Page
      filterBar={<FilterBar includeAggregation />}
      pageTitle="Dashboard"
      pageSubtitle="Track your project and goal with full information"
      keyMetrics={<MMKeyMetrics />}
      extraButtons={<GenAIActionButtons />}>
      <Overview />
    </Page>
  );
};
